export enum ApiVersion {
    NONE = '',
    V2 = 'v2/',
    V3 = 'v3/',
    V4 = 'v4/',
}
